module.exports = __webpack_public_path__ + "img/recent-work-06.52c7ac86.jpg";